module.exports = __webpack_public_path__ + "static/images/power-list2.3735ff4.png";